﻿import { formatString } from './stringUtils';
import { inRange } from './numberUtils';

function cloneDate(value) {
	return new Date(value);
}

export function addSeconds(date, seconds) {
	const clone = cloneDate(date);
	clone.setSeconds(clone.getSeconds() + seconds);
	return clone;
}

export function addMinutes(date, minutes) {
	const clone = cloneDate(date);
	clone.setMinutes(clone.getMinutes() + minutes);
	return clone;
}

export function addHours(date, hours) {
	const clone = cloneDate(date);
	clone.setHours(clone.getHours() + hours);
	return clone;
}

export function addDays(date, days) {
	const clone = cloneDate(date);
	clone.setDate(clone.getDate() + days);
	return clone;
}

export function addWeeks(date, weeks) {
	return addDays(date, weeks * 7);
}

export function addMonths(date, months) {
	const clone = cloneDate(date);
	const originalDay = clone.getDate();

	clone.setMonth(clone.getMonth() + months);
	const currentDay = clone.getDate();

	if (originalDay !== currentDay) {
		clone.setDate(clone.getDate() - currentDay);
	}

	return clone;
}

export function addYears(date, years) {
	const clone = cloneDate(date);
	const originalDay = clone.getDate();

	clone.setFullYear(clone.getFullYear() + years);
	const currentDay = clone.getDate();

	if (originalDay !== currentDay) {
		clone.setDate(clone.getDate() - currentDay);
	}

	return clone;
}

export function getYMDHMS(date) {
	const clone = cloneDate(date);

	return {
		fullYear: clone.getFullYear().toString().padStart(4, '0'),
		month: (clone.getMonth() + 1).toString().padStart(2, '0'),
		day: clone.getDate().toString().padStart(2, '0'),
		hours: clone.getHours().toString().padStart(2, '0'),
		minutes: clone.getMinutes().toString().padStart(2, '0'),
		seconds: clone.getSeconds().toString().padStart(2, '0')
	};
}

export function toYMD(date, offSetHours = 0) {
	const ymdhms = getYMDHMS(addHours(date, offSetHours));
	return formatString('{0}-{1}-{2}', ymdhms.fullYear, ymdhms.month, ymdhms.day);
}

export function toYMDHM(date, offSetHours = 0) {
	const ymdhms = getYMDHMS(addHours(date, offSetHours));
	return formatString('{0}-{1}-{2} {3}:{4}', ymdhms.fullYear, ymdhms.month, ymdhms.day, ymdhms.hours, ymdhms.minutes);
}

export function toYMDHMS(date, offSetHours = 0) {
	const ymdhms = getYMDHMS(addHours(date, offSetHours));
	return formatString('{0}-{1}-{2} {3}:{4}:{5}', ymdhms.fullYear, ymdhms.month, ymdhms.day, ymdhms.hours, ymdhms.minutes, ymdhms.seconds);
}

export function deltaMilliSeconds(date, otherDate) {
	return cloneDate(date).getTime() - cloneDate(otherDate).getTime();
}

export function deltaSeconds(date, otherDate) {
	return deltaMilliSeconds(date, otherDate) / 1000;
}

export function deltaHours(date, otherDate) {
	return deltaSeconds(date, otherDate) / 3600;
}

export function deltaDays(date, otherDate) {
	return deltaHours(date, otherDate) / 24;
}

export function toUTC(date) {
	const clone = cloneDate(date);
	return addMinutes(clone, clone.getTimezoneOffset());
}

export function isDateInRange(date, minDate, maxDate, inclusive = false) {
	return inRange(cloneDate(date).getTime(), cloneDate(minDate).getTime(), cloneDate(maxDate).getTime(), inclusive);
}
